import { Field, Form } from 'react-final-form';
import '../../style/login.css';
import NumberField from '../utils/NumberField'
import { connect } from 'react-redux';
import { login, fetchCSRF } from '../../actions'
import { openSignup } from '../../actions'
import { Link } from 'react-router-dom'
import { useEffect, useRef, useState } from 'react';

const Login = (props) => {
    const param = props.match.params.pathParam
    const NumberErrorRef = useRef(false);
    const NumberErrorMssg = useRef(null)
    const [formError, setFormError] = useState({error: false, message: null})
    const {csrf, fetchCSRF, login} = props

    useEffect(() => {
        fetchCSRF()
    }, [fetchCSRF])

    const validateForm = () => {
        let error = {}
        return error
    }
    const submitForm = (formValues) => {
        const csrfHeader = {headers: {'X-CSRFToken': csrf}}
        login(formValues, setFormError, csrfHeader)
    }
    const validateNumber = (value) => {
        if (value){
            if (value[0].match(/[0-6a-zA-Z]/)){
                NumberErrorRef.current = true
                NumberErrorMssg.current = `Number cannot start with ${value[0]}`
            }
        }
        else{
            NumberErrorRef.current = false
            return undefined
        }
    }
    const PasswordValidate = (value) => {
        
    }
    return(
        <div className="form-container" style={{height: props.mobileNav ? "auto" : (window.innerHeight - 75 - 84) + "px"}}>
            <div className="leftContainer">
                <div className="half-container">
                    <h1 className="login-title">Login To get High-Quality workmanship at great Prices</h1>
                    <ul className="login-list">
                        <li className="login-list__item">For speedy repairs</li>
                        <li className="login-list__item">Prompt service you can depend on</li>
                        <li className="login-list__item">Save money on your repair projects.</li>
                        <li className="login-list__item">Deliver trusted repair services.</li>
                    </ul>
                </div>
            </div>
            <div className="rightContainer">
            {param === "signup" ? <div className="ui green message small">Account Created Sucessfully. You can Login Now</div> : ""}
                {/* <h1>Login To Corecare</h1> */}
                <Form validate={validateForm} onSubmit={submitForm} subscription={{ submitting: true, pristine: true}}>
                    {(formProps) => (
                        <form className="login-form ui huge form" onSubmit={formProps.handleSubmit}>
                            <div>
                                <Field name="number" validate={validateNumber}>
                                    {(fieldProps) => (
                                        <NumberField input={fieldProps.input} label="Mobile Number" meta={fieldProps.meta}/>
                                    )}
                                </Field>
                                <Field name="password" validate={PasswordValidate}>
                                    {(fieldProps1) => (
                                        <div className="field">
                                            <label>Password</label>
                                            <input placeholder="password" type="password" {...fieldProps1.input}/>
                                        </div>
                                    )}
                                </Field>
                                <div className="login-forget-password">
                                    <Link to="/login/forgot_password" className="forgot-password" >Forgot password?</Link>
                                </div>
                                <div className="login-button-group">
                                    <button className="ui secondary button" onClick={() => props.openSignup()} type="button">
                                        Signup
                                    </button>
                                    <button className="ui positive right labeled icon button" type="submit">
                                        Login
                                        <i className="checkmark icon"></i>
                                    </button>
                            </div>
                            </div>
                            <div className={`ui message red ${NumberErrorRef.current || formError.error ? "visible" : "hidden"}`}>
                                <p>{NumberErrorMssg.current || formError.message}</p>
                            </div>
                        </form>
                    )}
                </Form>
                </div>
        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        mobileNav: state.mobileNav,
        csrf: state.csrf,
    }
}
export default connect(mapStateToProps, { login, openSignup, fetchCSRF })(Login)